/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Map_UnavailableInputs */

const en_colleague_map_unavailable = /** @type {(inputs: Colleague_Map_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The map could not be loaded. It needs an internet connection.`)
};

const ja_colleague_map_unavailable = /** @type {(inputs: Colleague_Map_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地図を読み込めませんでした。インターネット接続が必要です。`)
};

const fr_colleague_map_unavailable = /** @type {(inputs: Colleague_Map_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La carte n’a pas pu être chargée. Une connexion Internet est nécessaire.`)
};

const de_colleague_map_unavailable = /** @type {(inputs: Colleague_Map_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Karte konnte nicht geladen werden. Sie benötigt eine Internetverbindung.`)
};

/**
* | output |
* | --- |
* | "The map could not be loaded. It needs an internet connection." |
*
* @param {Colleague_Map_UnavailableInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_map_unavailable = /** @type {((inputs?: Colleague_Map_UnavailableInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Map_UnavailableInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_map_unavailable(inputs)
	if (locale === "ja") return ja_colleague_map_unavailable(inputs)
	if (locale === "fr") return fr_colleague_map_unavailable(inputs)
	return de_colleague_map_unavailable(inputs)
});